import React from "react";
import Marquee from "react-fast-marquee";
import { LotusMark } from "./LotusMark";

const ITEMS = [
  "Licensed & Insured",
  "Eco-Friendly Disposal",
  "Upfront Pricing",
  "Same-Day Estimates",
  "Professional Crew",
  "Fast Response",
  "5-Star Service",
];

export const BrandMarquee = () => (
  <div className="border-y border-white/10 bg-[#0d0d0d] py-6 marquee-mask">
    <Marquee speed={40} gradient={false} autoFill pauseOnHover>
      {ITEMS.map((item, i) => (
        <div key={i} className="flex items-center gap-6 px-6">
          <span className="font-heading font-bold uppercase tracking-tight text-2xl md:text-3xl text-white/85">
            {item}
          </span>
          <LotusMark size={26} />
        </div>
      ))}
    </Marquee>
  </div>
);

export default BrandMarquee;
